import { Injectable } from '@angular/core';

import { DeleteCommandService } from 'pbc.angular';

import { IDeleteFeldRequest, IDeleteFeldResponse } from 'fa-kt.types';

@Injectable({
  providedIn: 'root',
})
export class DeleteFeldCommandService extends DeleteCommandService<IDeleteFeldRequest, IDeleteFeldResponse> {
  readonly route = 'felder/feld';
}
